import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "sceneConstructorMenu" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" < ")
const _hoisted_3 = {
  key: 2,
  class: "sceneConstructorMenu_withArrows"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 512 512" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "m256 266l-160 162 0-60 160-159 160 160 0 59z" })
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  ref: "scrollable",
  class: "sceneConstructorMenu__scrollable"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 512 512" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "m256 266l-160 162 0-60 160-159 160 160 0 59z" })
], -1)
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showBackButton)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "sceneConstructorMenu__back",
          onClick: _cache[0] || (_cache[0] = () => _ctx.$emit('goBack'))
        }, [
          _hoisted_2,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('scene_constructor.go_back')), 1)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.showArrows)
      ? _renderSlot(_ctx.$slots, "default", { key: 1 })
      : _createCommentVNode("", true),
    (_ctx.showArrows)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("a", {
            class: "sceneConstructorMenu__arrowTop",
            onClick: _cache[1] || (_cache[1] = () => _ctx.scrollTop())
          }, _hoisted_5),
          _createElementVNode("div", _hoisted_6, [
            _renderSlot(_ctx.$slots, "default")
          ], 512),
          _createElementVNode("a", {
            class: "sceneConstructorMenu__arrowBottom",
            onClick: _cache[2] || (_cache[2] = () => _ctx.scrollBottom())
          }, _hoisted_8)
        ]))
      : _createCommentVNode("", true)
  ]))
}